  $(document).ready(function () {
    var arrowLeft = "<svg width='12' height='18' viewBox='0 0 12 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M4.4374 8.99907L11.0371 15.5988L9.15148 17.4844L0.666204 8.99907L9.15148 0.51387L11.0371 2.39947L4.4374 8.99907Z' fill='white'/></svg>"
    var arrowRight = "<svg width='12' height='18' viewBox='0 0 12 18' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M7.5626 8.99907L1.96289 15.5988L3.84852 17.4844L12.3338 8.99907L3.84852 0.51387L1.96289 2.39947L7.5626 8.99907Z' fill='white'/></svg>"
    $('.testimonials .owl-carousel').owlCarousel({
      loop: true,
      margin: 25,
      dots:false,
      nav: true,
      navText: [arrowLeft, arrowRight],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        600: {
          items: 1.4,
        },
        1000: {
          items: 1.4,
        }
      }
    });
    $('.benefits-carousel').owlCarousel({
      loop: true,
      margin: 20,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1.2
        },
        768: {
          items: 1.5
        },
        1200: {
          items: 1.8
        }
      }
    });
    document.querySelectorAll('.accordion-header').forEach(header => {
    header.addEventListener('click', () => {
        const content = header.nextElementSibling;
        const icon = header.querySelector('.toggle-icon');
        const isOpen = content.classList.contains('open');

        // Close all accordions
        document.querySelectorAll('.accordion-content').forEach(c => {
            c.style.maxHeight = null;
            c.classList.remove('open');
            c.style.display = "none";
        });
        document.querySelectorAll('.toggle-icon').forEach(i => i.textContent = "+");

        // Open the clicked one
        if (!isOpen) {
            content.classList.add('open');
            content.style.maxHeight = "none";
            content.style.display = "flex";
            icon.textContent = "–";
        }
    });
});

// ✅ Open the first accordion by default
const firstHeader = document.querySelector('.accordion-header');
if (firstHeader) {
    const firstContent = firstHeader.nextElementSibling;
    const firstIcon = firstHeader.querySelector('.toggle-icon');
    firstContent.classList.add('open');
    firstContent.style.maxHeight = "none";
    firstContent.style.display = "flex";
    firstIcon.textContent = "–";
}
  const marquee = document.getElementById("marquee");
  if (marquee) {
  marquee.innerHTML += marquee.innerHTML; // Duplicate

  let distance = marquee.scrollWidth / 2;

  gsap.to(marquee, {
    x: -distance,
    duration: 15,
    ease: "linear",
    repeat: -1
  });
  }
});
